export const apiUrl = "https://api.meaffiliatehub.com";
export const s3Url = "https://afiliate-hub-bucket.s3.eu-north-1.amazonaws.com";

export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
